module.exports = __webpack_public_path__ + "static/media/9.d018ed25.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/9.png
// module id = 1330
// module chunks = 0